import React from 'react';
import PropTypes from 'prop-types';
import styles from './VehicleState.module.scss';
import { Form, Icon, Loader } from 'semantic-ui-react';

const VehicleState = ({ state, isVin, hideCheck }) => {
	return (
		<Form.Field className={styles.loadingBox}>
			{state.loading && (
				<React.Fragment>
					<Loader active inline />
					<span className={styles.validating}>Validating vehicle information</span>
				</React.Fragment>
			)}


			{!hideCheck && !state.loading && state.valid && <Icon name='check' color='green' />}

			{!hideCheck && !state.loading && !state.valid && <Icon name='close' color='red' />}
			{isVin && state.vehicle && (
				<span className={styles.vin}>
					{state.vehicle.year} {state.vehicle.make} {state.vehicle.model}
				</span>
			)}
		</Form.Field>
	);
};

VehicleState.propTypes = {
    state: PropTypes.any.isRequired,
    isVin: PropTypes.bool 
};

export default VehicleState;
